module.exports = __webpack_public_path__ + "static/bkg-matching-is-easy-fb6b88dbfdac4d62aacb7d69b20eb72b.jpg";